import { readResponse } from './readResponse';
const authentication = require('../../../react-azure-adb2c2').default;







export const list = (values: any) => {
  //   if(values.date1){
  //   const date1 = new Date(values.date1);
  //   const year = date1.getFullYear();
  //   const month = date1.getMonth() + 1;
  //   const day = date1.getDate();
  //   values.date1 = year + '/' + month + '/' + day
  //   }
  //   if(values.date2){

  //   const date2 = new Date(values.date2);
  //   const year2 = date2.getFullYear();
  //   const month2 = date2.getMonth() + 1;
  //   const day2 = date2.getDate();

  //   values.date2 = year2 + '/' + month2 + '/' + day2
  // }
  // values.output =values.output===true?1:0

  // let url = `https://homestationapi.azurewebsites.net/api/kyousai?output=`+values.output+'&name='+values.name+'&date1='+values.date1+'&date2='+values.date2;
  // let url = `https://localhost:44341/api/Kyousai`;
  // let url = `https://moniesapi.azurewebsites.net/api/v1/kyousais`;
  // let url = `https://localhost:44341/api/banks?output=`+values.output+'&name='+values.name+'&date1='+values.date1+'&date2='+values.date2;

  // alert(url)
  const url = process.env.REACT_APP_API_BASE_URL + `/api/v1/kyousais`;
  // let url = `http://localhost:5000/api/v1/kyousais`;
  const token = authentication.getAccessToken();
  // console.log(JSON.stringify(values))
  // alert(JSON.stringify(values))
  return fetch(url, {
    method: 'post',
    body: JSON.stringify(values),
    headers: { 'Authorization': 'Bearer ' + token, 'Content-type': 'application/json; charset=UTF-8' },
  }).then(readResponse).then(res => res.json())
    .then(payload => ({ payload }))
    .catch(error => ({ error }));



  //  return  fetch(url, {
  //             method: 'get',
  //             // body: JSON.stringify(search),

  //             headers: { 'Authorization': 'Bearer ' + token, 'Content-type': 'application/json; charset=UTF-8' },

  //         }).then(res => res.json())
  //         .then(payload => ({ payload }))
  //             .catch(error => ({ error }));
  //       return  fetch(url, {
  //       method: 'get',
  //       // body: JSON.stringify(accountinglistset),

  //       headers: { 'Authorization': 'Bearer ' + token, 'Content-type': 'application/json; charset=UTF-8' },

  //   })
  //   .then(res => res.json())
  //   .then(payload => ({ payload }))
  //       .catch(error => ({ error }));






};






export const update = (values: any) => {
  const url = process.env.REACT_APP_API_BASE_URL + `/api/v1/kyousais/update`;
  // let url = `http://localhost:5000/api/v1/kyousais/update`;
  // alert(url)


  const token = authentication.getAccessToken();
  // alert(url)
  return fetch(url, {
    method: 'post',
    body: JSON.stringify(values),
    headers: { 'Authorization': 'Bearer ' + token, 'Content-type': 'application/json; charset=UTF-8' },
  }).then(readResponse).then(res => res.json())
    .then(payload => ({ payload }))
    .catch(error => ({ error }));



  //  return  fetch(url, {
  //             method: 'get',
  //             // body: JSON.stringify(search),

  //             headers: { 'Authorization': 'Bearer ' + token, 'Content-type': 'application/json; charset=UTF-8' },

  //         }).then(res => res.json())
  //         .then(payload => ({ payload }))
  //             .catch(error => ({ error }));
  //       return  fetch(url, {
  //       method: 'get',
  //       // body: JSON.stringify(accountinglistset),

  //       headers: { 'Authorization': 'Bearer ' + token, 'Content-type': 'application/json; charset=UTF-8' },

  //   })
  //   .then(res => res.json())
  //   .then(payload => ({ payload }))
  //       .catch(error => ({ error }));






};



export const delete_kyousais = (values: any) => {
  const url = process.env.REACT_APP_API_BASE_URL + `/api/v1/kyousais/deletekyousais`;
  // let url = `http://localhost:5000/api/v1/kyousais/deletekyousais`;


  // alert(url)

  const token = authentication.getAccessToken();
  // alert(url)
  return fetch(url, {
    method: 'post',
    body: JSON.stringify(values),
    headers: { 'Authorization': 'Bearer ' + token, 'Content-type': 'application/json; charset=UTF-8' },
  }).then(readResponse).then(res => res.json())
    .then(payload => ({ payload }))
    .catch(error => ({ error }));





};



export const upload_csv = (payload: any) => {
  // File normalization
  let file: File | null = null;
  const f: any = payload ? (payload as any).file : undefined;

  if (typeof FileList !== 'undefined' && f instanceof FileList) {
    file = f.length > 0 ? f.item(0) : null;
  } else if (Array.isArray(f)) {
    file = f.length > 0 ? f[0] : null;
  } else if (f instanceof File) {
    file = f as File;
  }

  if (!file) {
    throw new Error('ファイルが未指定です');
  }

  // Optional: CSV extension check
  if (!/\.csv$/i.test(file.name)) {
    console.warn('拡張子が .csv ではありません:', file.name);
  }

  const formData = new FormData();
  formData.append('file', file); // This MUST match the backend .single("file")
  
  const url = process.env.REACT_APP_API_BASE_URL + `/api/v1/kyousais/uploadcsv`;
  const token = authentication.getAccessToken();
  
  // Important: Do NOT set Content-Type header when sending FormData
  // The browser will automatically set it with the correct boundary
  return fetch(url, {
    method: 'post',
    body: formData,
    headers: { 
      'Authorization': 'Bearer ' + token
      // NO Content-Type header here!
    },
  }).then(readResponse).then(res => res.json())
    .then(payload => ({ payload }))
    .catch(error => ({ error }));
};


// export const detail = (Id: number) => {

//             const url = `https://homestationapi.azurewebsites.net/api/RentContracts/` + Id;

//             const token = authentication.getAccessToken();

//             return fetch(url, {
//                 headers: { 'Authorization': 'Bearer ' + token }
//             }).then(res => res.json())
//                 .then(payload => ({ payload }))
//                 .catch(error => ({ error }));


//     }




export const matching = (values: any) => {
  const url = process.env.REACT_APP_API_BASE_URL + `/api/v1/kyousais/matching`;
  // let url = `http://localhost:5000/api/v1/kyousais/matching`;


  // alert(url)

  const token = authentication.getAccessToken();
  // alert(url)
  return fetch(url, {
    method: 'get',
    // body: JSON.stringify(values),
    headers: { 'Authorization': 'Bearer ' + token, 'Content-type': 'application/json; charset=UTF-8' },
  }).then(readResponse).then(res => res.json())
    .then(payload => ({ payload }))
    .catch(error => ({ error }));

};



export const downloadcsv = (values: any) => {


  const url = process.env.REACT_APP_API_BASE_URL + `/api/v1/kyousais`;
  // const url = `http://localhost:5000/api/v1/kyousais`;

  // let url = `https://localhost:44341/api/RentContractAccounting`;

  const token = authentication.getAccessToken();
  values.csv = 1

  // alert(JSON.stringify(accountinglistset))
  return fetch(url, {
    method: 'post',
    body: JSON.stringify(values),

    headers: { 'Authorization': 'Bearer ' + token, 'Content-type': 'application/json; charset=UTF-8' },

  }).then(readResponse).then(response => response.blob())
    .then(payload => ({ payload }))
    // .then(res => res.json())
    // .then(payload => ({ payload }))
    .catch(error => ({ error }));






};